module.exports = __webpack_public_path__ + "img/google-play-badge-it.55b37e91.png";